import ComparisonEditing from './comparison-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class ComparisonUI extends Plugin {
    init() { }
}
export default class Comparison extends Plugin {
    static get requires() {
        return [ComparisonEditing, ComparisonUI];
    }
}
